import React, { useReducer, useContext, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import DynamicFont from "react-dynamic-font";
import { CusButton } from "../../Components/From/Button";
import { AsyncModel } from "../AsyncModel/AsyncModel";
import Tool_CusSp from "../../Components/Tools/Tool_CusSp";
import Tool_mealListWithoutSplit from "../Tools/Tool_mealListWithoutSplit";
import Tool_ServeBeforeMeal from "../Tools/Tool_ServeBeforeMeal";
import { Global } from "../../App";
import _ from "lodash";
import { saveTempOrder } from "../../Api/GetOrder";
// switch lang
import { langStringToCode } from "../../Share/Tools/switchLang";
// api
import { getSpecificProductItem } from "../../Api/GetProduct";
import Tool_ServeBeforeNoodleSoup from "../Tools/Tool_ServeBeforeNoodleSoup";

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case "UPDATE_STATE":
      payload.forEach((i) => {
        newState[i.key] = i.val;
      });
      return newState;
    default:
      return newState;
  }
};

/**
 *
 * @param {object} props
 *
 * 本次步驟會影響的global state
 *
 * currentStep (3.1 => 3 )
 * currentQrStep (1.1 => 1 )
 * mealDetail
 * mealOrderDetail
 */

function OrderStep_3_mealInfo(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, dispatch] = useReducer(reducer, {
    specificationData: null,
    currModify: {},
    isAddNew: false,
    specPopupSetting: {
      toggle: false,
      productName: "",
      specName: "",
      dineInTaste: [],
      takeoutTaste: [],
      disableTakeoutState: false,
    },
  });
  const [desertToggle, setDesertToggle] = useState(false);

  const [DTtoggle, setDTtoggle] = useState(false);
  const [isDTrecord, setisDTrecord] = useState(false);
  const [DTModel, setDTModel] = useState(false);
  const [DTvalue, setDTvalue] = useState(0);
  const [noodleSoupModel, setNoodleSoupModel] = useState(false);

  // 解析物件
  function splitDineType(data) {
    //data = _.cloneDeep(data);
    // 外帶
    let takeout = data.reduce((currProduct, itemProduct) => {
      itemProduct = {
        ...itemProduct,
        specification: itemProduct.specification.reduce(
          (currSpec, itemSpec) => {
            // 只取特性為[外帶]的組合
            itemSpec = {
              ...itemSpec,
              combination: itemSpec.combination.filter((f) => f.takeout),
            };
            // 此組合都沒有[外帶]特性時
            if (itemSpec.combination.length <= 0) {
              // 找出此組合在此的index標號
              // let findIndex = itemProduct.specification.findIndex(f=>f.id === itemSpec.id)
              // 刪除此規格下index標號的規格
              // itemProduct.specification.splice(findIndex, 1);
              return [...currSpec];
            } else {
              return [...currSpec, itemSpec];
            }
          },
          []
        ),
      };
      if (itemProduct.specification.length <= 0) {
        return [...currProduct];
      } else {
        return [...currProduct, itemProduct];
      }
    }, []);
    // 內用
    // console.log(data);
    let dineIn = data.reduce((currProduct, itemProduct) => {
      itemProduct = {
        ...itemProduct,
        specification: itemProduct.specification.reduce(
          (currSpec, itemSpec) => {
            // 只取特性為[內用]的組合
            itemSpec = {
              ...itemSpec,
              combination: itemSpec.combination.filter((f) => !f.takeout),
            };
            // console.log(itemSpec.combination);
            // 此組合都沒有[內用]特性時
            // console.log(itemSpec);
            if (itemSpec.combination.length <= 0) {
              // 找出此組合在此的index標號
              // let findIndex = itemProduct.specification.findIndex(f=>f.id === itemSpec.id)
              // 刪除此規格下index標號的規格
              // itemProduct.specification.splice(findIndex, 1);
              return [...currSpec];
            } else {
              return [...currSpec, itemSpec];
            }
          },
          []
        ),
      };
      if (itemProduct.specification.length <= 0) {
        return [...currProduct];
      } else {
        return [...currProduct, itemProduct];
      }
    }, []);
    //console.log('takeout', takeout);
    //console.log('dineIn', dineIn);
    return { takeout: takeout, dineIn: dineIn };
  }

  // 處理要回傳的資料格式
  function handlePostOrder(data) {
    let outputFormat = data.map((eachProduct) => ({
      id: eachProduct.id,
      specification: eachProduct.specification.map((eachSpec) => ({
        id: eachSpec.id,
        status: eachSpec.status,
        combination: eachSpec.combination.map((eachCombi) => ({
          ...eachCombi,
        })),
      })),
    }));
    // 照id排序
    outputFormat.sort((a, b) => {
      return a.id > b.id ? 1 : -1;
    });
    return outputFormat;
  }

  // 處理特口、外帶狀態相同的組合要合併成同一欄
  function merge(data) {
    let deep;
    if (!data) {
      deep = _.cloneDeep(state.specificationData);
    } else {
      deep = _.cloneDeep(data);
    }

    let isEquals = (a, b) => {
      return (
        a.takeout === b.takeout &&
        a.taste.sort().toString() === b.taste.sort().toString()
      );
    };
    const { specification } = deep;
    specification.map((spec) => {
      const combin = spec.combination.reduce((current, item) => {
        const findIndex = current.findIndex((item1) => isEquals(item, item1));
        if (findIndex === -1) {
          return [...current, item];
        } else {
          const nextCurrent = current.slice(0);
          const isLimit =
            item.quantity + nextCurrent[findIndex].quantity >= 99
              ? 99
              : item.quantity + nextCurrent[findIndex].quantity;
          if (item.quantity + nextCurrent[findIndex].quantity > 99)
            AsyncModel({
              title: globalState.langFile["popup.itemLimit"],
              cancelBtnText: globalState.langFile["popup.buttonCancel"],
              confirmBtnText: globalState.langFile["popup.buttonConfirm"],
            });

          nextCurrent[findIndex] = {
            ...nextCurrent[findIndex],
            quantity: isLimit,
          };
          return nextCurrent;
        }
      }, []);
      spec.combination = combin;
    });
    return deep;
  }

  // 四捨五入至小數點第n位
  const formatNumber = (value, pos) => {
    const float = Math.pow(10, pos);
    return (Math.round(value * float) / float).toFixed(pos);
  };

  // 紀錄電子商務
  function recordECommerce() {
    window.dataLayer = window.dataLayer || [];
    let productList = [];
    let pushObj = {
      event: "changeCart",
      ecommerce: {},
    };
    // 找出當前的餐點是否有記錄在 globalState.customer.mealOrderDetail
    let findThisMeal = globalState.customer.mealOrderDetail.find(
      (f) => f.id === globalState.customer.mealDetail.id
    );

    if (findThisMeal) {
      function simplifySpecification(specification) {
        let returnArray = [];
        specification.map((eachSpec) => {
          eachSpec.combination.map((eachCombi) => {
            returnArray.push({
              id: eachSpec.id,
              name: eachSpec.name,
              quantity: eachCombi.quantity,
              takeout: eachCombi.takeout,
              taste: eachCombi.taste,
            });
          });
        });
        return returnArray;
      }

      // 簡化後
      const thisSimplify = simplifySpecification(findThisMeal.specification),
        stateSimplify = simplifySpecification(
          state.specificationData.specification
        );

      function comparer(otherArray) {
        return function (current) {
          return (
            otherArray.filter((other) => {
              return (
                other.id === current.id &&
                other.name === current.name &&
                other.takeout === current.takeout &&
                JSON.stringify(other.taste) === JSON.stringify(current.taste) &&
                other.quantity === current.quantity
              );
            }).length === 0
          );
        };
      }

      const onlyInThis = thisSimplify
          .filter(comparer(stateSimplify))
          .filter((f) => f.quantity !== 0),
        onlyInState = stateSimplify
          .filter(comparer(thisSimplify))
          .filter((f) => f.quantity !== 0);
      let addProduct = [],
        removeProduct = [],
        notAddProduct = [];

      if (onlyInThis.length === 0 && onlyInState.length !== 0) {
        // 僅新增
        addProduct = onlyInState;
      } else if (onlyInThis.length !== 0 && onlyInState.length === 0) {
        // 僅移除
        removeProduct = onlyInThis;
      } else {
        // 新增移除皆有
        onlyInThis.map((eachOnlyInThis) => {
          let diffQuantity = onlyInState.find(
            (f) =>
              f.id === eachOnlyInThis.id &&
              f.name === eachOnlyInThis.name &&
              f.takeout === eachOnlyInThis.takeout &&
              JSON.stringify(f.taste) === JSON.stringify(eachOnlyInThis.taste)
          );

          if (diffQuantity) {
            // 不須發送新增的商品
            notAddProduct.push(diffQuantity);
          } else {
            removeProduct.push(eachOnlyInThis);
          }
        });
        addProduct = onlyInState.filter(comparer(notAddProduct));
      }

      function ecFormatSpecification(specification) {
        let returnArray = [];
        specification.map((eachSpec) => {
          returnArray.push({
            name: `${state.specificationData.name}${
              eachSpec.name ? ` ${eachSpec.name}` : ""
            }`,
            id: String(eachSpec.id),
            category: state.specificationData.categoryName,
            variant: eachSpec.takeout ? "Takeout" : "DineIn",
          });
        });
        return returnArray;
      }
      // 有增加商品
      if (addProduct.length) {
        pushObj.ecommerce.add = {
          actionField: { step: 1 },
          products: ecFormatSpecification(addProduct),
        };
      }
      // 有移除商品
      if (removeProduct.length) {
        pushObj.ecommerce.remove = {
          actionField: { step: 1 },
          products: ecFormatSpecification(removeProduct),
        };
      }
    } else {
      // 原本不在清單，增加購物車
      state.specificationData.specification.map((eachSpec) => {
        eachSpec.combination.map((eachCombi) => {
          // 有數量才紀錄
          if (eachCombi.quantity) {
            productList.push({
              name: `${state.specificationData.name}${
                eachSpec.name ? ` ${eachSpec.name}` : ""
              }`,
              id: String(eachSpec.id),
              // 'price': formatNumber(eachSpec.price, 2),
              category: state.specificationData.categoryName,
              variant: eachCombi.takeout ? "Takeout" : "DineIn",
              // 'quantity': eachCombi.quantity
            });
          }
        });
      });
      pushObj.ecommerce.add = {
        actionField: { step: 1 },
        products: productList,
      };
    }
    // 有紀錄才push
    if (pushObj.ecommerce.add || pushObj.ecommerce.remove) {
      window.dataLayer.push(pushObj);
    }

    console.log("update end");
  }

  // 加點API
  async function apiSaveTempOrder(saveData) {
    const backToStep3 = () => {
      dispatchGlobal({
        type: "UPDATE",
        payload: [
          {
            key: "customer",
            val: {
              ...globalState.customer,
              currentStep: "3",
              currentQrStep: "1",
              mealDetail: "",
            },
          },
        ],
      });
    };
    let res;
    try {
      res = await saveTempOrder(saveData);
      console.log("save");
    } catch (err) {
      return backToStep3();
    }

    let { errCode } = res.data;
    if (res && errCode === 200) {
    } else {
      return backToStep3();
    }
  }

  // 搜尋當前要尋找的產品
  async function apiProductItem(langId, productId) {
    const backToStep3 = () => {
      dispatchGlobal({
        type: "UPDATE",
        payload: [
          {
            key: "customer",
            val: {
              ...globalState.customer,
              currentStep: "3",
              currentQrStep: "1",
              mealDetail: "",
            },
          },
        ],
      });
    };
    try {
      const res = await getSpecificProductItem(langId, productId);
      const { errCode, product } = res.data;
      const newSpecData = {
        ...product,
      };

      if (errCode == 200) {
        newSpecData.mealTag = newSpecData.allergen.concat(
          newSpecData.recommend
        );
        // 找出當前的餐點是否有記錄在 globalState.customer.mealOrderDetail
        let findThisMeal = globalState.customer.mealOrderDetail.find(
          (f) => f.id === globalState.customer.mealDetail.id
        );
        if (!findThisMeal) {
          // 試用模式=3 僅限外帶 預設給外帶
          newSpecData.specification = product.specification.map((e) => ({
            ...e,
            combination: [
              {
                takeout: e.applyMode === 3,
                taste: (e.applyMode === 3
                  ? product.takeoutTaste
                  : product.stayInTaste
                )
                  .filter((def) => def.preset)
                  .map((e) => e.id),
                quantity: 0,
                originalQuantity: 0,
              },
            ],
          }));
        } else {
          newSpecData.specification = product.specification.map(
            (eachSpec, specIndex) => {
              const currSpec = eachSpec;
              let MealTemp = findThisMeal.specification.find((e) => {
                return e.id === eachSpec.id;
              });
              if (MealTemp && MealTemp.combination.length > 0) {
                return { ...MealTemp };
              } else {
                // takeout: 可能需要改 e.applyMode === 3
                return {
                  ...currSpec,
                  // 保留新的status
                  // status: newSpecData.specification[specIndex].status,
                  combination: [
                    {
                      takeout: eachSpec.applyMode === 3,
                      taste: newSpecData.stayInTaste
                        .filter((def) => def.preset)
                        .map((e) => e.id),
                      quantity: 0,
                      originalQuantity: 0,
                    },
                  ],
                };
              }
            }
          );
        }
        return { product, newSpecData };
      } else {
        const Alert = await AsyncModel({
          title: globalState.langFile[`errorMsg.errorCode_${errCode}`],
          confirmBtnText: globalState.langFile["popup.buttonConfirm"],
        });
        if (Alert) return backToStep3();
      }
    } catch (err) {
      console.error("ProductItem error.");
      const Alert = await AsyncModel({
        title: globalState.langFile[`errorMsg.errorCode_${407}`],
        confirmBtnText: globalState.langFile["popup.buttonConfirm"],
      });
      if (Alert) return backToStep3();
    }
  }

  // get api
  useEffect(() => {
    let langCode = langStringToCode(globalState.langType);
    let currentProductId = globalState.customer.mealDetail.id;

    async function handler() {
      const getProductItem = await apiProductItem(langCode, currentProductId);
      if (getProductItem) {
        const mergeData = {
          ...merge(getProductItem.newSpecData),
          specification: merge(getProductItem.newSpecData).specification.map(
            (item, index) => {
              return {
                ...item,
                status: getProductItem.product.specification[index].status,
              };
            }
          ),
        };
        dispatch({
          type: "UPDATE_STATE",
          payload: [
            {
              key: "specificationData",
              val: mergeData,
              // val: merge(getProductItem.newSpecData)
            },
          ],
        });
        dispatchGlobal({
          type: "UPDATE",
          payload: [
            {
              key: "customer",
              val: {
                ...globalState.customer,
                mealDetail: {
                  ...globalState.customer.mealDetail,
                  description: getProductItem.product.description,
                  mealTag: getProductItem.product.allergen.concat(
                    getProductItem.product.recommend
                  ),
                  name: getProductItem.product.name,
                  typeName: getProductItem.product.categoryName,
                  stayInTaste: getProductItem.product.stayInTaste,
                },
              },
            },
          ],
        });
        //判斷有沒有隨餐上
        const hasItemWithId41 = getProductItem.product.stayInTaste.some(
          (item) => item.id === 41
        );
        if (hasItemWithId41) {
          setDTtoggle(true);
        }
      }
    }
    handler();
  }, [globalState.langType]);

  function $haveSoldOut() {
    return state.specificationData.specification.some((eachSpec) => {
      // 狀態是售畢
      return (
        eachSpec.status === 3 &&
        eachSpec.combination.some((eachCombi) => {
          // 且數量不為零
          return eachCombi.quantity > 0;
        })
      );
    });
  }
  function $atLeastOne() {
    return state.specificationData.specification.some((eachSpec) => {
      return eachSpec.combination.some((eachCombi) => {
        // 至少有一個商品大於0
        return eachCombi.quantity > 0;
      });
    });
  }
  function $haveOriginMeal() {
    return globalState.customer.mealOrderDetail.find((e) => {
      return e.id === state.specificationData.id;
    });
  }
  async function saveOrderAndGoBack() {
    let Goback;
    let deepCopy = _.cloneDeep(globalState.customer.mealOrderDetail);

    let TempMealOrderDetail = globalState.customer.mealOrderDetail;
    let NewDetail;
    let currProduct = _.cloneDeep(state.specificationData);
    let productIndex = deepCopy.findIndex((f) => f.id === currProduct.id);
    currProduct.specification.reduce((currSpec, itemSpec) => {
      itemSpec.combination = itemSpec.combination.filter((f) => f.quantity > 0);
      return [...currSpec, itemSpec];
    }, []);
    // 此餐點的組合加總
    let count = currProduct.specification.reduce((currSpec, itemSpec) => {
      itemSpec = itemSpec.combination.length;
      return currSpec + itemSpec;
    }, 0);
    //判斷有沒有選餐上餐時間

    // if(isDTrecord===false && DTtoggle == true){
    //   setDTModel(true)
    //   return
    // }

    // 判斷要回去的步驟頁面
    let gotoStep = globalState.customer.isFromOrderDetail ? "4" : "3";
    let gotoQrStep = globalState.customer.isFromOrderDetail ? "2" : "1";
    // globalState 原本有此餐點的訂單
    if (productIndex > -1) {
      deepCopy[productIndex] = currProduct;

      if (count === 0) {
        deepCopy.splice(productIndex, 1);

        Goback = () =>
          dispatchGlobal({
            type: "UPDATE",
            payload: [
              {
                key: "customer",
                val: {
                  ...globalState.customer,
                  currentStep: gotoStep,
                  currentQrStep: gotoQrStep,
                  mealDetail: "",
                  mealOrderDetail: deepCopy,
                  // mealOrderDetail: UpdateDetail
                },
              },
            ],
          });
      } else {
        Goback = () =>
          dispatchGlobal({
            type: "UPDATE",
            payload: [
              {
                key: "customer",
                val: {
                  ...globalState.customer,
                  currentStep: gotoStep,
                  currentQrStep: gotoQrStep,
                  mealDetail: "",
                  mealOrderDetail: deepCopy,
                },
              },
            ],
          });
      }
      NewDetail = deepCopy;
      recordECommerce(deepCopy);
    } else {
      // globalState 原本沒有此餐點的訂單
      let newMealOrderDetail = [...deepCopy, currProduct];
      _.orderBy(
        newMealOrderDetail,
        ["category_sequence", "sequence"],
        ["asc", "asc"]
      );
      // 此餐點的總數量 = 0 (沒有點餐)
      if (count === 0) {
        //TempMealOrderDetail = '';
        // 直接返回上一頁

        Goback = () =>
          dispatchGlobal({
            type: "UPDATE",
            payload: [
              {
                key: "customer",
                val: {
                  ...globalState.customer,
                  //currentStep: gotoStep,
                  //currentQrStep: gotoQrStep,
                  mealDetail: "",
                },
              },
            ],
          });
      } else {
        TempMealOrderDetail = newMealOrderDetail;
        // 此餐點的總數量 != 0 (有點餐)
        // 新增[...原有餐點, 現在的餐點]
        Goback = () =>
          dispatchGlobal({
            type: "UPDATE",
            payload: [
              {
                key: "customer",
                val: {
                  ...globalState.customer,
                  currentStep: gotoStep,
                  currentQrStep: gotoQrStep,
                  mealDetail: "",
                  mealOrderDetail: newMealOrderDetail,
                },
              },
            ],
          });
        NewDetail = newMealOrderDetail;
        recordECommerce(newMealOrderDetail);
      }
    }

    // 加點模式 點單即存資料
    if (
      globalState.ordermode === "addorder" &&
      globalState.customer.orderInfo.tempOrderID
    ) {
      // if (globalState.customer.orderInfo.tempOrderID) {

      let OlddineIn = splitDineType(TempMealOrderDetail).dineIn.filter((e) => {
        return e.id === state.specificationData.id;
      });
      let Oldtakeout = splitDineType(TempMealOrderDetail).takeout.filter(
        (e) => {
          return e.id === state.specificationData.id;
        }
      );
      let NewdineIn = splitDineType(NewDetail).dineIn.filter((e) => {
        return e.id === state.specificationData.id;
      });
      let Newtakeout = splitDineType(NewDetail).takeout.filter((e) => {
        return e.id === state.specificationData.id;
      });
      let dineIn = [];
      let takeout = [];
      NewdineIn = handlePostOrder(NewdineIn);
      Newtakeout = handlePostOrder(Newtakeout);
      OlddineIn = handlePostOrder(OlddineIn);
      Oldtakeout = handlePostOrder(Oldtakeout);
      // 比對新舊單 合併差異部分
      for (let i = 0; i < state.specificationData.specification.length; i++) {
        if (NewdineIn[0]) {
          let New = NewdineIn[0].specification.filter((e) => {
            return e.id === state.specificationData.specification[i].id;
          });
          let Temp = dineIn.filter((e) => {
            return e.id === NewdineIn[0].id;
          });
          if (New.length > 0) {
            if (Temp.length === 0) {
              dineIn.push(NewdineIn[0]);
            }
          } /*
                  else {

                    dineIn.push(
                      {
                        id: state.specificationData.id,
                        specification: [
                          {
                            id: state.specificationData.specification[i].id,
                            status: 2,
                            combination: [{
                              taste: [],
                              tastestr: "",
                              takeout: false,
                              quantity: 0
                            }]
                          }
                        ]
                      })
                  }*/
        }

        if (Newtakeout[0]) {
          let Out = Newtakeout[0].specification.filter((e) => {
            return e.id === state.specificationData.specification[i].id;
          });
          let Temp = takeout.filter((e) => {
            return e.id === Newtakeout[0].id;
          });
          if (Out.length > 0) {
            if (Temp.length === 0) {
              takeout.push(Newtakeout[0]);
            }
          }
          /*
                  else {
                    takeout.push(
                      {
                        id: state.specificationData.id,
                        specification: [
                          {
                            id: state.specificationData.specification[i].id,
                            status: 2,
                            combination: [{
                              taste: [],
                              tastestr: "",
                              takeout: true,
                              quantity: 0
                            }]
                          }
                        ]
                      })
                  }*/
        }
      }

      // 如找到內用暫存但新單沒有該品項即歸0
      if (dineIn.length > 0) {
        OlddineIn.map((e) => {
          e.specification.map((e1) => {
            let Data = dineIn[0].specification.filter((x) => {
              return x.id == e1.id;
            });
            if (Data.length == 0) {
              e1.combination[0].quantity = 0;
              dineIn[0].specification.push(e1);
            }
          });
        });
      } else {
        OlddineIn.map((e) => {
          e.specification.map((e1) =>
            e1.combination.map((e2) => (e2.quantity = 0))
          );
          dineIn.push(e);
        });
      }

      // 如找到外帶暫存但新單沒有該品項即歸0
      if (takeout.length > 0) {
        Oldtakeout.map((e) => {
          e.specification.map((e1) => {
            let Data = takeout[0].specification.filter((x) => {
              return x.id == e1.id;
            });
            if (Data.length == 0) {
              e1.combination[0].quantity = 0;
              takeout[0].specification.push(e1);
            }
          });
        });
      } else {
        Oldtakeout.map((e) => {
          e.specification.map((e1) =>
            e1.combination.map((e2) => (e2.quantity = 0))
          );
          takeout.push(e);
        });
      }
      await apiSaveTempOrder({
        isNew: false,
        queueNumber: globalState.customer.orderInfo.queueNumber,
        queueCode: globalState.customer.orderInfo.queueCode,
        countryID: globalState.customer.orderInfo.country,
        storeID: globalState.customer.orderInfo.selectedBranch.branchCode,
        adultsCount: globalState.customer.orderInfo.numberOfAdult,
        childCount: globalState.customer.orderInfo.numberOfChild,
        userEmail: null,
        totalPrice: 0,
        waiterID: null,
        languageID: 1,
        QRCodeID: null,
        tempOrderID: globalState.customer.orderInfo.tempOrderID,
        tempOrderGroupID: globalState.customer.orderInfo.tempOrderGroupID,
        mainOrderCode: globalState.customer.orderInfo.mainOrderCode, //加點模式要傳
        posCode: globalState.customer.orderInfo.posCode, //加點模式要傳
        tableNo: globalState.customer.orderInfo.tableNo, //加點模式要傳
        dineIn: dineIn,
        takeout: takeout,
      });
      Goback();
    } else {
      Goback();
    }
  }
  //監聽餐前餐後彈窗
  useEffect(() => {
    if (isDTrecord === true) {
      saveOrderAndGoBack();
    }
  }, [DTModel, noodleSoupModel]);

  if (
    !globalState.customer.mealDetail ||
    !state.specificationData ||
    !globalState.customer.mealDetail.mealTag
  )
    return null;
  return (
    <div className="Pages col d-flex flex-column align-items-center p-0 pt-3 pt-sm-0 mh-80">
      <div className="w-100 Pages__title mealInfo__title mb-3">
        {/* {globalState.customer.mealDetail.name} */}
        <DynamicFont content={globalState.customer.mealDetail.name} />
      </div>
      <div className="Pages__subtitle txtColorBrown mb-3">
        {globalState.customer.mealDetail.typeName}
      </div>
      <div className="Pages__space w-100 mb-3">
        <div
          className="Pages__space__item w-100  p-2 p-sm-3 text-justify"
          dangerouslySetInnerHTML={{
            __html: globalState.customer.mealDetail.description,
          }}
        ></div>
        {/* <div className="Pages__space__item w-100 p-2 p-sm-3 text-justify">
          {globalState.customer.mealDetail.description}
         這段寫在後端 樣式可以調整mealInfo_desc_note的css
          <br />
          <div class="mealInfo_desc_note">※製餐時間較長，請耐心等候</div>
          <div></div>
        </div> */}

        <div className="Pages__mealsTagSpace">
          {globalState.customer.mealDetail.mealTag.map((tagItem, index) => (
            <div className="Pages__mealsTag p-1 mr-1 mb-1">
              <img
                style={{ height: "25px" }}
                className="mr-1"
                src={tagItem.icon}
                alt=""
              />
              <span>{tagItem.description}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="Pages__mealsDetail Pages__section d-flex flex-column align-items-center">
        <div className="Pages__section">
          {console.log("state.specificationData 3.1", state.specificationData)}
          {/* 特口的規格 */}
          <Tool_mealListWithoutSplit
            user="customer"
            device={globalState.device}
            data={state.specificationData}
            onDelete={async (newData) => {
              const alert = await AsyncModel({
                title: globalState.langFile["popup.msgDelete"],
                showCancelBtn: true,
                cancelBtnText: globalState.langFile["popup.buttonCancel"],
                confirmBtnText: globalState.langFile["popup.buttonConfirm"],
              });
              if (alert) {
                dispatch({
                  type: "UPDATE_STATE",
                  payload: [{ key: "specificationData", val: newData.newData }],
                });
              }
            }}
            onUpdate={(newData) => {
              dispatch({
                type: "UPDATE_STATE",
                payload: [
                  {
                    key: "specificationData",
                    val: merge(newData),
                  },
                ],
              });
            }}
            onEditTaste={(newData) => {
              dispatch({
                type: "UPDATE_STATE",
                payload: [
                  {
                    key: "specPopupSetting",
                    val: newData.specPopupSetting,
                  },
                  {
                    key: "currModify",
                    val: newData.currModify,
                  },
                ],
              });
            }}
            onAddNewSpec={(newCurrModify) => {
              dispatch({
                type: "UPDATE_STATE",
                payload: [
                  {
                    key: "specPopupSetting",
                    val: newCurrModify.specPopupSetting,
                  },
                  {
                    key: "isAddNew",
                    val: newCurrModify.isAddNew,
                  },
                  {
                    key: "currModify",
                    val: newCurrModify.currModify,
                  },
                ],
              });
            }}
          />
        </div>
      </div>
      <div className="Pages__section d-flex justify-content-center mt-4 mb-4">
        <CusButton.White
          className="p-3 pl-sm-5 pr-sm-5 mt-2 mb-2 mr-3 col col-sm-auto"
          children={
            <FormattedMessage id="pages.takeOrder.step3_1.buttonBack" />
          }
          onClick={() => {
            // 判斷要回去的步驟頁面
            let gotoStep = globalState.customer.isFromOrderDetail ? "4" : "3";
            let gotoQrStep = globalState.customer.isFromOrderDetail ? "2" : "1";
            let deepCopy = _.cloneDeep(globalState.customer.mealOrderDetail);
            let currProduct = _.cloneDeep(state.specificationData);
            let productIndex = deepCopy.findIndex(
              (f) => f.id === currProduct.id
            );
            if (productIndex > -1) {
              deepCopy[productIndex].specification.reduce(
                (currSpec, itemSpec) => {
                  itemSpec.combination = itemSpec.combination.filter(
                    (f) => f.quantity > 0
                  );
                  return [...currSpec, itemSpec];
                },
                []
              );
            }

            dispatchGlobal({
              type: "UPDATE",
              payload: [
                {
                  key: "customer",
                  val: {
                    ...globalState.customer,
                    currentStep: gotoStep,
                    currentQrStep: gotoQrStep,
                    mealDetail: "",
                    mealOrderDetail: deepCopy,
                  },
                },
              ],
            });
          }}
        />
        <CusButton.Red
          style={{ width: "200px" }}
          className="p-3 pl-sm-5 pr-sm-5 mt-2 mb-2 ml-3 col col-sm-auto"
          children={
            <FormattedMessage
              id={`pages.takeOrder.step3_1.${
                $haveSoldOut() ? "buttonHaveSoldOut" : "buttonSave"
              }`}
            />
          }
          disabled={!$haveOriginMeal() && ($haveSoldOut() || !$atLeastOne())}
          onClick={() => {
            //檢查有沒有餐前餐後特口
            const hasDTtaste = globalState.customer.mealDetail.stayInTaste.some(
              (taste) => taste.id === 41 //隨餐上
            );

            //檢查dtf_id是否為元盅雞麵或元盅牛肉麵 是的話有湯麵分離特口
            const hasNoodleSoupSeparateTaste = [
              "1-009-01", //元盅雞麵
              "1-009-02", //元盅牛肉麵
            ].includes(state.specificationData.dtf_id);

            //檢查室是內用且數量大於0
            const hasItems = state.specificationData.specification.some(
              (item) =>
                item.combination.some(
                  (combination) =>
                    combination.takeout === false && combination.quantity > 0
                )
            );

            // if (isDTrecord === false && DTtoggle == true && hasItems)
            if (hasItems && hasDTtaste) {
              setDTModel(true);
              // saveOrderAndGoBack();
              return;
            } else if (hasItems && hasNoodleSoupSeparateTaste) {
              setNoodleSoupModel(true);
            } else {
              saveOrderAndGoBack();
            }
          }}
          //舊的
          // onClick={async () => {
          //   let Goback;
          //   let deepCopy = _.cloneDeep(globalState.customer.mealOrderDetail);

          //   let TempMealOrderDetail = globalState.customer.mealOrderDetail;
          //   let NewDetail;
          //   let currProduct = _.cloneDeep(state.specificationData);
          //   let productIndex = deepCopy.findIndex(
          //     (f) => f.id === currProduct.id
          //   );
          //   currProduct.specification.reduce((currSpec, itemSpec) => {
          //     itemSpec.combination = itemSpec.combination.filter(
          //       (f) => f.quantity > 0
          //     );
          //     return [...currSpec, itemSpec];
          //   }, []);
          //   // 此餐點的組合加總
          //   let count = currProduct.specification.reduce(
          //     (currSpec, itemSpec) => {
          //       itemSpec = itemSpec.combination.length;
          //       return currSpec + itemSpec;
          //     },
          //     0
          //   );
          //   //判斷有沒有選餐上餐時間
          //   // if (
          //   //   globalState.customer.mealDetail.type === 11 &&
          //   //   productIndex > -1

          //   // ) {
          //   //   setDesertToggle(true)
          //   //  return
          //   // }

          //   // 判斷要回去的步驟頁面
          //   let gotoStep = globalState.customer.isFromOrderDetail ? "4" : "3";
          //   let gotoQrStep = globalState.customer.isFromOrderDetail ? "2" : "1";
          //   // globalState 原本有此餐點的訂單
          //   if (productIndex > -1) {
          //     deepCopy[productIndex] = currProduct;

          //     if (count === 0) {
          //       deepCopy.splice(productIndex, 1);

          //       Goback = () =>
          //         dispatchGlobal({
          //           type: "UPDATE",
          //           payload: [
          //             {
          //               key: "customer",
          //               val: {
          //                 ...globalState.customer,
          //                 currentStep: gotoStep,
          //                 currentQrStep: gotoQrStep,
          //                 mealDetail: "",
          //                 mealOrderDetail: deepCopy,
          //                 // mealOrderDetail: UpdateDetail
          //               },
          //             },
          //           ],
          //         });
          //     } else {
          //       Goback = () =>
          //         dispatchGlobal({
          //           type: "UPDATE",
          //           payload: [
          //             {
          //               key: "customer",
          //               val: {
          //                 ...globalState.customer,
          //                 currentStep: gotoStep,
          //                 currentQrStep: gotoQrStep,
          //                 mealDetail: "",
          //                 mealOrderDetail: deepCopy,
          //               },
          //             },
          //           ],
          //         });
          //     }
          //     NewDetail = deepCopy;
          //     recordECommerce(deepCopy);
          //   } else {
          //     // globalState 原本沒有此餐點的訂單
          //     let newMealOrderDetail = [...deepCopy, currProduct];
          //     _.orderBy(
          //       newMealOrderDetail,
          //       ["category_sequence", "sequence"],
          //       ["asc", "asc"]
          //     );
          //     // 此餐點的總數量 = 0 (沒有點餐)
          //     if (count === 0) {
          //       //TempMealOrderDetail = '';
          //       // 直接返回上一頁

          //       Goback = () =>
          //         dispatchGlobal({
          //           type: "UPDATE",
          //           payload: [
          //             {
          //               key: "customer",
          //               val: {
          //                 ...globalState.customer,
          //                 //currentStep: gotoStep,
          //                 //currentQrStep: gotoQrStep,
          //                 mealDetail: "",
          //               },
          //             },
          //           ],
          //         });
          //     } else {
          //       TempMealOrderDetail = newMealOrderDetail;
          //       // 此餐點的總數量 != 0 (有點餐)
          //       // 新增[...原有餐點, 現在的餐點]
          //       Goback = () =>
          //         dispatchGlobal({
          //           type: "UPDATE",
          //           payload: [
          //             {
          //               key: "customer",
          //               val: {
          //                 ...globalState.customer,
          //                 currentStep: gotoStep,
          //                 currentQrStep: gotoQrStep,
          //                 mealDetail: "",
          //                 mealOrderDetail: newMealOrderDetail,
          //               },
          //             },
          //           ],
          //         });
          //       NewDetail = newMealOrderDetail;
          //       recordECommerce(newMealOrderDetail);
          //     }
          //   }

          //   // 加點模式 點單即存資料
          //   if (
          //     globalState.ordermode === "addorder" &&
          //     globalState.customer.orderInfo.tempOrderID
          //   ) {
          //     // if (globalState.customer.orderInfo.tempOrderID) {

          //     let OlddineIn = splitDineType(TempMealOrderDetail).dineIn.filter(
          //       (e) => {
          //         return e.id === state.specificationData.id;
          //       }
          //     );
          //     let Oldtakeout = splitDineType(
          //       TempMealOrderDetail
          //     ).takeout.filter((e) => {
          //       return e.id === state.specificationData.id;
          //     });
          //     let NewdineIn = splitDineType(NewDetail).dineIn.filter((e) => {
          //       return e.id === state.specificationData.id;
          //     });
          //     let Newtakeout = splitDineType(NewDetail).takeout.filter((e) => {
          //       return e.id === state.specificationData.id;
          //     });
          //     let dineIn = [];
          //     let takeout = [];
          //     NewdineIn = handlePostOrder(NewdineIn);
          //     Newtakeout = handlePostOrder(Newtakeout);
          //     OlddineIn = handlePostOrder(OlddineIn);
          //     Oldtakeout = handlePostOrder(Oldtakeout);
          //     // 比對新舊單 合併差異部分
          //     for (
          //       let i = 0;
          //       i < state.specificationData.specification.length;
          //       i++
          //     ) {
          //       if (NewdineIn[0]) {
          //         let New = NewdineIn[0].specification.filter((e) => {
          //           return e.id === state.specificationData.specification[i].id;
          //         });
          //         let Temp = dineIn.filter((e) => {
          //           return e.id === NewdineIn[0].id;
          //         });
          //         if (New.length > 0) {
          //           if (Temp.length === 0) {
          //             dineIn.push(NewdineIn[0]);
          //           }
          //         } /*
          //         else {

          //           dineIn.push(
          //             {
          //               id: state.specificationData.id,
          //               specification: [
          //                 {
          //                   id: state.specificationData.specification[i].id,
          //                   status: 2,
          //                   combination: [{
          //                     taste: [],
          //                     tastestr: "",
          //                     takeout: false,
          //                     quantity: 0
          //                   }]
          //                 }
          //               ]
          //             })
          //         }*/
          //       }

          //       if (Newtakeout[0]) {
          //         let Out = Newtakeout[0].specification.filter((e) => {
          //           return e.id === state.specificationData.specification[i].id;
          //         });
          //         let Temp = takeout.filter((e) => {
          //           return e.id === Newtakeout[0].id;
          //         });
          //         if (Out.length > 0) {
          //           if (Temp.length === 0) {
          //             takeout.push(Newtakeout[0]);
          //           }
          //         }
          //         /*
          //         else {
          //           takeout.push(
          //             {
          //               id: state.specificationData.id,
          //               specification: [
          //                 {
          //                   id: state.specificationData.specification[i].id,
          //                   status: 2,
          //                   combination: [{
          //                     taste: [],
          //                     tastestr: "",
          //                     takeout: true,
          //                     quantity: 0
          //                   }]
          //                 }
          //               ]
          //             })
          //         }*/
          //       }
          //     }

          //     // 如找到內用暫存但新單沒有該品項即歸0
          //     if (dineIn.length > 0) {
          //       OlddineIn.map((e) => {
          //         e.specification.map((e1) => {
          //           let Data = dineIn[0].specification.filter((x) => {
          //             return x.id == e1.id;
          //           });
          //           if (Data.length == 0) {
          //             e1.combination[0].quantity = 0;
          //             dineIn[0].specification.push(e1);
          //           }
          //         });
          //       });
          //     } else {
          //       OlddineIn.map((e) => {
          //         e.specification.map((e1) =>
          //           e1.combination.map((e2) => (e2.quantity = 0))
          //         );
          //         dineIn.push(e);
          //       });
          //     }

          //     // 如找到外帶暫存但新單沒有該品項即歸0
          //     if (takeout.length > 0) {
          //       Oldtakeout.map((e) => {
          //         e.specification.map((e1) => {
          //           let Data = takeout[0].specification.filter((x) => {
          //             return x.id == e1.id;
          //           });
          //           if (Data.length == 0) {
          //             e1.combination[0].quantity = 0;
          //             takeout[0].specification.push(e1);
          //           }
          //         });
          //       });
          //     } else {
          //       Oldtakeout.map((e) => {
          //         e.specification.map((e1) =>
          //           e1.combination.map((e2) => (e2.quantity = 0))
          //         );
          //         takeout.push(e);
          //       });
          //     }
          //     await apiSaveTempOrder({
          //       isNew: false,

          //       queueNumber: globalState.customer.orderInfo.queueNumber,
          //       queueCode: globalState.customer.orderInfo.queueCode,
          //       countryID: globalState.customer.orderInfo.country,
          //       storeID:
          //         globalState.customer.orderInfo.selectedBranch.branchCode,
          //       adultsCount: globalState.customer.orderInfo.numberOfAdult,
          //       childCount: globalState.customer.orderInfo.numberOfChild,
          //       userEmail: null,
          //       totalPrice: 0,
          //       waiterID: null,
          //       languageID: 1,
          //       QRCodeID: null,
          //       tempOrderID: globalState.customer.orderInfo.tempOrderID,
          //       tempOrderGroupID: globalState.customer.orderInfo.tempOrderGroupID,
          //       mainOrderCode: globalState.customer.orderInfo.mainOrderCode, //加點模式要傳
          //       posCode: globalState.customer.orderInfo.posCode, //加點模式要傳
          //       tableNo: globalState.customer.orderInfo.tableNo, //加點模式要傳
          //       dineIn: dineIn,
          //       takeout: takeout,
          //     });
          //     Goback();
          //   } else {
          //     Goback();
          //   }
          // }}
        />
      </div>

      {/* 特口彈跳視窗 */}
      {(() => {
        if (!state.specPopupSetting.toggle) return null;
        return (
          <Tool_CusSp
            productName={state.specPopupSetting.productName}
            specName={state.specPopupSetting.specName}
            takeoutTaste={state.specPopupSetting.takeoutTaste}
            dineInTaste={state.specPopupSetting.dineInTaste}
            takeoutState={
              state.specPopupSetting.applyMode === 3
                ? true
                : state.currModify.takeout
            } // 若僅限外帶，預設給true
            disableTakeoutState={state.specPopupSetting.disableTakeoutState}
            applyModeState={state.specPopupSetting.applyMode}
            disableTasteList={window.env.HIDE_USER_TASTE !== "0"} // 是否隱藏特口選項
            selectedItems={state.currModify.taste}
            onClose={(e) => {
              dispatch({
                type: "UPDATE_STATE",
                payload: [
                  {
                    key: "specPopupSetting",
                    val: {
                      toggle: false,
                      productName: "",
                      specName: "",
                      dineInTaste: [],
                      takeoutTaste: [],
                    },
                  },
                  { key: "currModify", val: {} },
                  { key: "isAddNew", val: false },
                ],
              });
            }}
            onSelectItem={(e) => {
              e.taste.sort();
              let deep = _.cloneDeep(state.specificationData);
              let { specification } = deep;
              // 是否為新增組合
              if (state.isAddNew) {
                let findCurrentSpec = specification.find(
                  (f) => f.id === state.currModify.specId
                );

                // takeout: 可能需要改 e.applyMode === 3
                findCurrentSpec.combination = [
                  ...findCurrentSpec.combination,
                  {
                    takeout: e.takeoutState,
                    taste: e.taste,
                    quantity: 1,
                  },
                ];
                dispatch({
                  type: "UPDATE_STATE",
                  payload: [
                    {
                      key: "specificationData",
                      val: merge(deep),
                    },
                    {
                      key: "specPopupSetting",
                      val: {
                        toggle: false,
                        productName: "",
                        specName: "",
                        dineInTaste: [],
                        takeoutTaste: [],
                      },
                    },
                    { key: "currModify", val: {} },
                    { key: "isAddNew", val: false },
                  ],
                });
              } else {
                specification.map((_eachSp) => {
                  if (_eachSp.id === state.currModify.specId) {
                    // 找到當前要修改的combination
                    let findCurrentCombi = _eachSp.combination.find((f) => {
                      return (
                        f.takeout === state.currModify.takeout &&
                        f.taste.sort().toString() ===
                          state.currModify.taste.sort().toString() &&
                        f.quantity === state.currModify.quantity
                      );
                    });

                    // 更新當前要修改的combination的特口
                    if (
                      findCurrentCombi.taste.sort().toString() !==
                        e.taste.sort().toString() ||
                      findCurrentCombi.takeout !== e.takeoutState
                    ) {
                      findCurrentCombi.taste = e.taste;
                      findCurrentCombi.takeout = e.takeoutState;

                      dispatch({
                        type: "UPDATE_STATE",
                        payload: [
                          {
                            key: "specificationData",
                            val: merge(deep),
                          },
                          {
                            key: "specPopupSetting",
                            val: {
                              toggle: false,
                              productName: "",
                              specName: "",
                              dineInTaste: [],
                              takeoutTaste: [],
                            },
                          },
                          { key: "currModify", val: {} },
                          { key: "isAddNew", val: false },
                        ],
                      });
                    }
                  }
                });
              }
            }}
          />
        );
      })()}
      {/* 餐前餐後彈跳視窗 */}
      {DTModel == true ? (
        <Tool_ServeBeforeMeal
          setDTModel={setDTModel}
          setisDTrecord={setisDTrecord}
          isDTrecord={isDTrecord}
          setDTvalue={setDTvalue}
          DTvalue={DTvalue}
          data={state.specificationData}
          onEditTaste={(newData) => {
            dispatch({
              type: "UPDATE_STATE",
              payload: [
                {
                  key: "specPopupSetting",
                  val: newData.specPopupSetting,
                },
                {
                  key: "currModify",
                  val: newData.currModify,
                },
              ],
            });
          }}
          saveOrderAndGoBack={saveOrderAndGoBack}
          hadleDT={async (newvalue) => {
            const newTasteValue = [newvalue]; // New taste value to be added
            dispatch({
              type: "UPDATE_STATE",
              payload: [
                {
                  key: "specificationData",
                  val: {
                    ...state.specificationData,
                    specification: state.specificationData.specification.map(
                      (spec, index) => {
                        if (
                          spec.combination.some(
                            (comb) => comb.quantity > 0 && !comb.takeout
                          )
                        ) {
                          return {
                            ...spec,
                            combination: spec.combination.map((comb) => {
                              if (comb.quantity > 0 && !comb.takeout) {
                                return {
                                  ...comb,
                                  taste: newTasteValue,
                                };
                              }
                              return comb;
                            }),
                          };
                        }
                        return spec;
                      }
                    ),
                  },
                },
              ],
            });
            setisDTrecord(true);
          }}
        />
      ) : (
        ""
      )}
      {/* {湯麵是否分離彈跳視窗} */}
      {noodleSoupModel === true && (
        <Tool_ServeBeforeNoodleSoup
          setDTModel={setNoodleSoupModel}
          setisDTrecord={setisDTrecord}
          isDTrecord={isDTrecord}
          setDTvalue={setDTvalue}
          DTvalue={DTvalue}
          data={state.specificationData}
          onEditTaste={(newData) => {
            dispatch({
              type: "UPDATE_STATE",
              payload: [
                {
                  key: "specPopupSetting",
                  val: newData.specPopupSetting,
                },
                {
                  key: "currModify",
                  val: newData.currModify,
                },
              ],
            });
          }}
          saveOrderAndGoBack={saveOrderAndGoBack}
          hadleDT={async (newvalue) => {
            const newTasteValue = [newvalue]; // New taste value to be added
            dispatch({
              type: "UPDATE_STATE",
              payload: [
                {
                  key: "specificationData",
                  val: {
                    ...state.specificationData,
                    specification: state.specificationData.specification.map(
                      (spec, index) => {
                        if (
                          spec.combination.some(
                            (comb) => comb.quantity > 0 && !comb.takeout
                          )
                        ) {
                          return {
                            ...spec,
                            combination: spec.combination.map((comb) => {
                              if (comb.quantity > 0 && !comb.takeout) {
                                return {
                                  ...comb,
                                  taste: newTasteValue,
                                };
                              }
                              return comb;
                            }),
                          };
                        }
                        return spec;
                      }
                    ),
                  },
                },
              ],
            });
            setisDTrecord(true);
          }}
        />
      )}
    </div>
  );
}

export default OrderStep_3_mealInfo;
